import { FloatingPortal, FloatingOverlay, FloatingFocusManager } from '@floating-ui/react';
import classnames from 'classnames';
import React__default from 'react';
import { useModalState } from './use_modal_state.js';
import { getHeadingId } from './utils.js';
import '../heading/index.js';
import '../scroll_parent/index.js';
import '../spinner/index.js';
import { overlay, animationStatus, spinner, modal, size, loading } from './modal.css.js';
import { Spinner } from '../spinner/spinner.js';
import { ScrollParent } from '../scroll_parent/scroll_parent.js';
import { HeadingLevelProvider } from '../heading/heading_level_provider.js';

const ModalContent = ({ children, className, ...rest }) => {
    const state = useModalState();
    const handleClick = React__default.useCallback((event) => event.stopPropagation(), []);
    return state.isMounted ? (React__default.createElement(FloatingPortal, null,
        React__default.createElement(FloatingOverlay, { lockScroll: true, className: classnames(overlay, animationStatus[state.transitionStatus]), 
            // Prevent click events on content propagating to potential parents that have onClick handlers defined.
            onClick: handleClick },
            React__default.createElement(FloatingFocusManager, { context: state.context, modal: true },
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Spinner, { className: classnames(spinner, animationStatus[state.transitionStatus]) }),
                    React__default.createElement(ScrollParent, { ...rest, labelledBy: !state.loading ? getHeadingId(state.id) : '', className: classnames(modal, size[state.size], animationStatus[state.transitionStatus], {
                            [loading]: state.loading,
                        }, className), ...state.getFloatingProps({
                            ref: state.refs.setFloating,
                        }) },
                        React__default.createElement(HeadingLevelProvider, { root: true }, children))))))) : null;
};

export { ModalContent };
